import BaseLayout from "./ui/layouts/BaseLayout";
import BackOfficeAppLayout from "./ui/layouts/BackOfficeAppLayout";
import FrontOfficeAppLayout from "./ui/layouts/FrontOfficeAppLayout";
import MikPortalAppLayout from "./ui/layouts/MikPortalAppLayout";
import RootLayout from "./ui/layouts/RootLayout";
import { AppConstants } from "./common/Constants";
import TLayoutMap from "./ui/layouts/TLayoutMap";

export interface TApplicationConfig {
  areas: string[];
  layouts: TLayoutMap;
}

export interface TApplication {
  name: string;
  configuration: TApplicationConfig;
}

let areas = {
  backoffice: [
    "authentication",
    "home",
    "codebook",
    "applicants",
    "reporting",
    "settings",
    "reports",
    "evaluations"
  ],
  frontoffice: [
    "authentication",
    "frontOfficeHome",
    "form",
    "settings",
    "requests"
  ],
  portal: ["mikPortal", "portalReporting"]
};

let layouts = {
  backoffice: {
    appLayout: BackOfficeAppLayout,
    baseLayout: BaseLayout,
    rootLayout: RootLayout
  },
  frontoffice: {
    appLayout: FrontOfficeAppLayout,
    baseLayout: BaseLayout,
    rootLayout: RootLayout
  },
  portal: {
    appLayout: MikPortalAppLayout,
    baseLayout: BaseLayout,
    rootLayout: RootLayout
  }
};

export default class ApplicationConfig {
  private application: TApplication;

  constructor(name: string) {
    this.application = this.configureApplication(name);
  }

  public getApplicationName() {
    return this.application.name;
  }

  private configureApplication(applicationName: string): TApplication {
    if (!Object.values(AppConstants).includes(applicationName)) {
      throw new Error("No application named " + applicationName);
    }

    let application: TApplication;

    application = {
      name: applicationName,
      configuration: {
        areas: areas[applicationName],
        layouts: layouts[applicationName]
      }
    };

    return application;
  }

  public get areas(): string[] {
    return this.application.configuration.areas;
  }

  public get layouts(): TLayoutMap {
    return this.application.configuration.layouts;
  }
}
